import { graphql } from "msw";
import withdrawalApplications from "../data/withdrawalApplications/withdrawalApplications";
import currencies from "../data/oms/currencies";

export const handlers = [
  graphql.query("getWithdrawalApplication", (req, res, ctx) => {
    const { id } = req.variables; //  eslint-disable-line no-unused-vars
    return res(
      ctx.delay(600),
      ctx.data({
        getCurrencies: currencies,
        getWithdrawalApplication: withdrawalApplications.find(
          (wa) => wa.id === id
        ),
      })
    );
  }),

  graphql.query("getWithdrawalApplications", (req, res, ctx) => {
    return res(
      ctx.delay(1000),
      ctx.data({
        getWithdrawalApplications: withdrawalApplications,
      })
    );
  }),

  graphql.mutation("updateWithdrawalApplication", (req, res, ctx) => {
    const {
      id,
      applicationNumber,
      projectId,
      operationId,
      requestedAmount,
      requestedCurrencyCode,
    } = req.variables;
    return res(
      ctx.delay(1000),
      ctx.status(200),
      ctx.data({
        createWithdrawalApplication: {
          id: id,
          applicationNumber: applicationNumber,
          requestedAmount: requestedAmount,
          requestedCurrency: {
            code: requestedCurrencyCode,
            name: "United States Dollar",
            decimals: 2,
          },
          project: {
            id: projectId,
            code: "EGY0094",
            name: "South Helawn Power Plant Project",
            country: {
              code: "EG",
              name: "Egypt",
            },
          },
          operation: {
            id: operationId,
            name: "Leasing / Islamic Development Bank",
          },
          state: "Submitted",
          attachments: [
            {
              fileName: "tes.pdf",
              fileSize: 223320,
              filePath: null,
              id: "6ce61d7d-5527-407d-8e6f-9e44ac81e3c5",
            },
          ],
        },
      })
    );
  }),

  graphql.mutation("createWithdrawalApplication", (req, res, ctx) => {
    const {
      applicationNumber,
      projectId,
      operationId,
      requestedAmount,
      requestedCurrencyCode,
    } = req.variables;

    if (applicationNumber === "1234") {
      return res(
        ctx.delay(1000),
        ctx.status(500),
        ctx.errors({
          errors: [
            {
              message:
                "A withdrawal application with the same number already exists for this project. Please specify a new one!",
              locations: [
                {
                  line: 2,
                  column: 3,
                },
              ],
              path: ["createWithdrawalApplication"],
              extensions: {
                occurredAt: "2021-02-23T18:17:12.186291",
                code: "VALIDATION_ERROR",
              },
            },
          ],
        })
      );
    } else if (applicationNumber === "12345") {
      return res(
        ctx.delay(1000),
        ctx.status(303),
        ctx.errors({
          errors: [
            {
              message: "File not Found",
              locations: [
                {
                  line: 2,
                  column: 3,
                },
              ],
              path: ["createWithdrawalApplication"],
              extensions: {
                occurredAt: "2021-02-23T18:17:12.186291",
                code: "VALIDATION_ERROR",
              },
            },
          ],
        })
      );
    } else {
      return res(
        ctx.delay(1000),
        ctx.status(200),
        ctx.data({
          createWithdrawalApplication: {
            id: "603534e1ed6cb629a9c2007f",
            applicationNumber: applicationNumber,
            requestedAmount: requestedAmount,
            requestedCurrency: {
              code: requestedCurrencyCode,
              name: "United States Dollar",
              decimals: 2,
            },
            project: {
              id: projectId,
              code: "EGY0094",
              name: "South Helawn Power Plant Project",
              country: {
                code: "EG",
                name: "Egypt",
              },
            },
            operation: {
              id: operationId,
              name: "Leasing / Islamic Development Bank",
            },
            state: "Submitted",
            attachments: [
              {
                fileName: "tes.pdf",
                fileSize: 223320,
                filePath: null,
                id: "6ce61d7d-5527-407d-8e6f-9e44ac81e3c5",
              },
            ],
          },
        })
      );
    }
  }),
];
